export const divisionOptions = [
    { value: 'Chattogram', label: 'Chattogram' },
    { value: 'Rajshahi', label: 'Rajshahi' },
    { value: 'Khulna', label: 'Khulna' },
    { value: 'Barisal', label: 'Barisal' },
    { value: 'Sylhet', label: 'Sylhet' },
    { value: 'Dhaka', label: 'Dhaka' },
    { value: 'Rangpur', label: 'Rangpur' },
    { value: 'Mymensingh', label: 'Mymensingh' },
];